import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

import '../node_modules/bootstrap/dist/js/bootstrap';
import './styles/index.css';
import './styles/vendor/cover.css';

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);

// test

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx